module.exports = __webpack_public_path__ + "static/companies-095affef48b3a0a698ffb63eca6d7a84.svg";